import { memo } from "react";

export const BookIcon = memo(() => (
  <svg viewBox="0 0 48 48" fill="none">
    <rect
      x="3"
      y="13"
      width="42"
      height="26"
      fill="#EA5A47"
      stroke="black"
      strokeLinejoin="round"
    />
    <rect x="6" y="36" width="36" height="3" fill="#76757E" stroke="black" />
    <rect
      x="6"
      y="11"
      width="36"
      height="25"
      fill="#FFB655"
      stroke="black"
      strokeLinejoin="round"
    />
    <path
      d="M9 16H21M9 21H21M9 26H21M9 31H21"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M27 16H39M27 21H39M27 26H39M27 31H39"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M24 11V39" stroke="black" strokeLinejoin="round" />
  </svg>
));
